import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  width: "60%",
  class: "text-left"
}
const _hoisted_2 = { width: "10%" }
const _hoisted_3 = { class: "d-flex justify-center" }
const _hoisted_4 = { width: "10%" }
const _hoisted_5 = { class: "d-flex justify-center" }
const _hoisted_6 = { width: "10%" }
const _hoisted_7 = { class: "d-flex justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_AuditChecks = _resolveComponent("AuditChecks")!
  const _component_AuditCheckEdition = _resolveComponent("AuditCheckEdition")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_tabs, {
        modelValue: _ctx.activeTab,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event)),
        style: {"border-radius":"16px","overflow":"hidden"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tab, {
            value: "Layouts",
            href: "#Layouts"
          }, {
            default: _withCtx(() => _cache[12] || (_cache[12] = [
              _createTextVNode("Dossiers de révision")
            ])),
            _: 1
          }),
          _createVNode(_component_v_tab, {
            value: "AuditChecks",
            href: "#AuditChecks"
          }, {
            default: _withCtx(() => _cache[13] || (_cache[13] = [
              _createTextVNode("Contrôles")
            ])),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_tabs_window, {
        modelValue: _ctx.activeTab,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.activeTab) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_window_item, { value: "Layouts" }, {
            default: _withCtx(() => [
              (!_ctx.$vuetify.display.mobile)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 0,
                    "no-gutters": "",
                    class: "my-3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn_primary, {
                            block: "",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'AccountingReviewLayout-new' })))
                          }, {
                            default: _withCtx(() => _cache[14] || (_cache[14] = [
                              _createTextVNode(" Ajouter ")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { class: "pl-2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: _ctx.search,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.search) = $event)),
                            "append-inner-icon": "$search",
                            label: "Recherche",
                            outlined: "",
                            "hide-details": "",
                            clearable: "",
                            "onClick:clear": _cache[3] || (_cache[3] = ($event: any) => (_ctx.search = '')),
                            density: "compact"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "2",
                        class: "pl-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_combobox, {
                            modelValue: _ctx.filterCompany,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filterCompany) = $event)),
                            items: _ctx.allAvailableCompanies,
                            label: "Société",
                            "item-title": "key",
                            dense: "",
                            outlined: "",
                            "hide-details": ""
                          }, null, 8, ["modelValue", "items"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "d-flex justify-center",
                style: _normalizeStyle('max-height:' + _ctx.maxHeight + ';' + 'overflow:auto')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "8" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        class: "default_card_wm",
                        style: {"background":"#fff !important"},
                        elevation: "0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, { class: "d-flex py-1" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "12" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_data_table, {
                                    title: "",
                                    headers: _ctx.headers,
                                    items: _ctx.sortedAccountingReviewLayouts,
                                    "items-per-page": -1,
                                    "hide-default-footer": "",
                                    class: "table"
                                  }, {
                                    item: _withCtx((props) => [
                                      (props.item)
                                        ? (_openBlock(), _createElementBlock("tr", {
                                            key: props.item.id
                                          }, [
                                            _cache[15] || (_cache[15] = _createElementVNode("td", { width: "5%" }, null, -1)),
                                            (props.item.name)
                                              ? (_openBlock(), _createElementBlock("td", _hoisted_1, _toDisplayString(props.item.name), 1))
                                              : _createCommentVNode("", true),
                                            _createElementVNode("td", _hoisted_2, [
                                              _createElementVNode("div", _hoisted_3, [
                                                _createVNode(_component_v_btn_icon, {
                                                  icon: 
                                                                _ctx.isAccountingFirmOwner(props.item)
                                                                    ? '$oss-edit'
                                                                    : '$oss-eye'
                                                            ,
                                                  color: "secondary",
                                                  elevation: "0",
                                                  onClick: ($event: any) => (
                                                                _ctx.$router.push({
                                                                    name: 'AccountingReviewLayout',
                                                                    params: {
                                                                        id: props.item.id,
                                                                    },
                                                                })
                                                            ),
                                                  disabled: _ctx.readOnly,
                                                  size: "x-small"
                                                }, null, 8, ["icon", "onClick", "disabled"])
                                              ])
                                            ]),
                                            _createElementVNode("td", _hoisted_4, [
                                              _createElementVNode("div", _hoisted_5, [
                                                _createVNode(_component_v_btn_icon, {
                                                  icon: "$oss-duplicate",
                                                  color: "secondary",
                                                  elevation: "0",
                                                  onClick: ($event: any) => (_ctx.duplicate(props.item.id)),
                                                  disabled: _ctx.readOnly,
                                                  size: "x-small"
                                                }, null, 8, ["onClick", "disabled"])
                                              ])
                                            ]),
                                            _createElementVNode("td", _hoisted_6, [
                                              _createElementVNode("div", _hoisted_7, [
                                                (_ctx.isAccountingFirmOwner(props.item))
                                                  ? (_openBlock(), _createBlock(_component_v_btn_trash, {
                                                      key: 0,
                                                      onClick: ($event: any) => {
                                                                _ctx.toggleDeleteAccountingReviewLayoutDialog();
                                                                _ctx.selectItemToDelete(props.item.id);
                                                            },
                                                      disabled: _ctx.readOnly,
                                                      size: "x-small"
                                                    }, null, 8, ["onClick", "disabled"]))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ]),
                                            _cache[16] || (_cache[16] = _createElementVNode("td", { width: "5%" }, null, -1))
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }, 8, ["headers", "items"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["style"]),
              (_ctx.deleteAccountingReviewLayoutDialog)
                ? (_openBlock(), _createBlock(_component_oss_dialog, {
                    key: 1,
                    modelValue: _ctx.deleteAccountingReviewLayoutDialog,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.deleteAccountingReviewLayoutDialog) = $event)),
                    title: "Souhaitez-vous vraiment supprimer ce dossier de révision ?",
                    validTitle: "Supprimer",
                    error: true,
                    onValid: _cache[6] || (_cache[6] = ($event: any) => (_ctx.deleteAccountingReviewLayout(_ctx.itemToDelete))),
                    onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.resetItemToDelete())),
                    "min-width": "1000px"
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: "AuditChecks" }, {
            default: _withCtx(() => [
              _createVNode(_component_AuditChecks, {
                auditCheckTypes: _ctx.auditCheckTypes,
                mode: "enableActions",
                ref: "auditChecks",
                onDisplayExistingAudit: _cache[8] || (_cache[8] = ($event: any) => (_ctx.displayExistingAudit($event)))
              }, null, 8, ["auditCheckTypes"]),
              (_ctx.displayAuditCheckEdition)
                ? (_openBlock(), _createBlock(_component_oss_dialog, {
                    key: 0,
                    modelValue: _ctx.displayAuditCheckEdition,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.displayAuditCheckEdition) = $event)),
                    title: "Affichage d'un contrôle",
                    validTitle: 
                        _ctx.auditToDisplay && _ctx.auditToDisplay.type === 'ACCOUNTING_REVIEW_MANUAL_CUSTOM'
                            ? 'Enregistrer'
                            : 'Fermer'
                    ,
                    onValid: _cache[10] || (_cache[10] = ($event: any) => (
                        _ctx.auditToDisplay && _ctx.auditToDisplay.type === 'ACCOUNTING_REVIEW_MANUAL_CUSTOM'
                            ? _ctx.validateModificatedAuditRow()
                            : _ctx.toggleDisplayAuditCheckEdition()
                    )),
                    "min-width": "1000px"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.displayAuditCheckEdition)
                        ? (_openBlock(), _createBlock(_component_AuditCheckEdition, {
                            key: 0,
                            ref: "auditCheckEdition",
                            auditToDisplay: _ctx.auditToDisplay,
                            readOnly: true
                          }, null, 8, ["auditToDisplay"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "validTitle"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}